export class SlideItem {
  constructor(
    public hash: string,
    public id: string,
    public link: string,
    public alt: string
  ) {}
}
